import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";


function Item({ image, lieu }) {

    let distance = "";

    if (lieu.distance < 1) {
        distance = (lieu.distance * 1000) + " m"
    } else {
        distance = lieu.distance + " km";
    }




    return (<div className="col-10">
        <div className="card mb-4 box-shadow">
            <Link to={"detail/" + lieu.designation} >

                <LazyLoadImage
                    src={lieu.pathToImage}
                    className="card-img-top"
                    alt={"photo de " + lieu.designation}
                >

                </LazyLoadImage>
            </Link>
            <div className="card-body">
                {
                    lieu.sendBy.name != "" && lieu.sendBy.pathToImage != "" && !lieu.anonymous &&
                    <p>
                        <small className="smalls">Ajouté par :
                        <span style={{ visibility: "hidden" }}>p</span>

                            <img style={{ width: '30px' }} src={lieu.sendBy.pathToImage} className="rounded-circle z-depth-0" alt="avatar image" />
                            <span style={{ visibility: "hidden" }}>p</span>

                            {lieu.sendBy.name}

                        </small>

                    </p>
                }
                <h5>{lieu.designation}</h5>
                <p className="card-text">
                    {lieu.description}
                </p>

                <p>
                    <small className="smalls">{lieu.selectedArrondisement}, {lieu.ville}</small>
                </p>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="btn-group">
                        <Link to={"detail/" + lieu.designation} className="btn btn-sm btn-outline-secondary">voir</Link>
                        <a href={"tel:" + lieu.telephone} className="btn btn-sm btn-outline-secondary">Appeler</a>
                    </div>
                    <i className="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small className="text-muted">
                        <i className="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> {distance} </small>
                </div>
            </div>
        </div>
    </div>);
}

function LargeItem({ image, lieu }) {
    let distance = "";

    if (lieu.distance < 1) {
        distance = (lieu.distance * 1000) + " m"
    } else {
        distance = lieu.distance + " km";
    
    }

    return (<div className="col-sm-6 col-md-6 col-lg-4">
        <div className="card mb-4 box-shadow">
            <Link to={"detail/" + lieu.designation} >
                <LazyLoadImage
                    src={lieu.pathToImage}
                    className="card-img-top"
                    alt={"photo de " + lieu.designation}
                >

                </LazyLoadImage>
            </Link>

            <div className="card-body">
                 {
                    lieu.sendBy.name != "" && lieu.sendBy.pathToImage != "" && !lieu.anonymous &&
                    <p>
                        <small className="smalls">Ajouté par :
                        <span style={{ visibility: "hidden" }}>p</span>

                            <img style={{ width: '30px' }} src={lieu.sendBy.pathToImage} className="rounded-circle z-depth-0" alt="avatar image" />
                            <span style={{ visibility: "hidden" }}>p</span>

                            {lieu.sendBy.name}

                        </small>

                    </p>
                }
                <h5>{lieu.designation}</h5>
                <p className="card-text">
                    {lieu.description}
                </p>
                <p>
                    <small className="smalls">{lieu.selectedArrondisement}, {lieu.ville}</small>
                </p>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="btn-group">
                        <Link to={"detail/" + lieu.designation} className="btn btn-sm btn-outline-secondary">voir</Link>
                        <a href={"tel:" + lieu.telephone} className="btn btn-sm btn-outline-secondary">Appeler</a>
                    </div>
                    <i className="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small className="text-muted">
                        <i className="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> {distance}</small>
                </div>
            </div>
        </div>
    </div>);
}

export { LargeItem };

export default Item;